/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TListRateSchedulesResponse } from '../models/TListRateSchedulesResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class RateScheduleService {
    /**
     * List the contracts Talon prices with, oldest first - the choices for a session or usage estimate's
     * contract
     * @returns TListRateSchedulesResponse TListRateSchedulesResponse
     * @throws ApiError
     */
    public static listRateSchedules(): CancelablePromise<TListRateSchedulesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/rate-schedules',
        });
    }
}
